export default {
  CURRENCY_REPOSITORY: Symbol.for('CURRENCY_REPOSITORY'),
  GET_ALL_CURRENCIES_QUERY: Symbol.for('GET_ALL_CURRENCIES_QUERY'),
  CURRENCY_STATE_MANAGER: Symbol.for('CURRENCY_STATE_MANAGER'),
};
